import { Action } from '@ngrx/store';
import {StopLicenseParams} from '../stop-license.model';

export enum StopLicenseActionTypes {
  LoadStopLicenses = '[StopLicense] Load StopLicenses',
  GetStopLicenses = '[StopLicense] Get StopLicenses',
  ClearStopLicenses = '[StopLicense] Clear StopLicenses',
}

export class LoadStopLicenses implements Action {
  readonly type = StopLicenseActionTypes.LoadStopLicenses;
}

export class GetStopLicenses implements Action {
  readonly type = StopLicenseActionTypes.GetStopLicenses;
  constructor(public payload: StopLicenseParams) {}
}



export type StopLicenseActions = LoadStopLicenses
  | GetStopLicenses;
